import {formatMoney} from "@shopify/theme-currency";

/**
 * checking if the bundle is out of stock
 * @return boolean
 * */

export function available(bundle) {
    bundle.bundle_components.forEach((variant) => {
        if (available_bundle_variants.indexOf(variant.id) === -1) {
            if ('replace_variant' in variant) {
                if (available_bundle_variants.indexOf(variant.replace_variant) === -1) {
                    bundle['sold'] = true;
                } else {
                    variant.id = variant.replace_variant;
                    variant.price = variant.replace_price;
                }
            } else {
                bundle['sold'] = true;
            }
        }
    });

    if (bundle.hasOwnProperty('free_components')) {
        bundle.free_components.free_bundle_componets.forEach((product) => {
            if (available_bundle_variants.indexOf(product.id) === -1) {
                if ('replace_variant' in product) {
                    if (available_bundle_variants.indexOf(product.replace_variant) === -1) {
                        bundle['sold'] = true;
                    } else {
                        product.id = product.replace_variant;
                        product.price = product.replace_price;
                    }
                } else {
                    bundle['sold'] = true;
                }
            }
        });
    }

    return bundle['sold'];
}
/**
 * getting the original price and the discounted price from the bundle object.
 * @return array
 *
 * */
export function getBundlePrice(bundle) {
    const discountGeneral = bundle.bundle_discount;
    let discountedPrice = 0;
    let originalPrice = 0;
    let discountedAmount = 1 - (discountGeneral * 0.01);
    for (let i = 0; i < bundle.bundle_components.length; i++) {
        const product = bundle.bundle_components[i];
        const qty = product.qty ? product.qty : 1;
        const price = available_bundle_variants[product.id] * qty;
        if(product.hasOwnProperty('discount')){
            discountedAmount = 1 - (product.discount * 0.01)
        } else {
            discountedAmount = 1 - (discountGeneral * 0.01);
        }
        const discountMath = price * discountedAmount;
        discountedPrice += discountMath;
        originalPrice += price;
    }

    return [formatMoney(discountedPrice, window.moneyFormat), formatMoney(originalPrice, window.moneyFormat)];
}

export function getBundle(bundleClass) {
    
    for(const bundle of bundles_array) {

        if(bundleClass == bundle.bundle_class) {
            return bundle;
        }

    }
    return null;
}